'use client';

import React, { useEffect, useRef } from 'react';
import { useGTM } from '@/features/Analytics';
import { featureTimeslotsConfig } from '@/shared/config/tests/e2e/features/booking';
import { DaysList } from './DaysList';
import { TimeSlotsList } from './TimeSlotsList';
import type { ISchedule } from '@/entities/booking/model/types';
import type { TimeSlotsUIProps } from '../../model/types';
export const TimeSlotsUI: React.FC<TimeSlotsUIProps> = props => {
  const {
    schedule,
    setSelectedSlot,
    selectedDay,
    scrollToSelected = false,
    selectedSlot,
    onDayClick,
    onSlotClick,
    mini,
    daysTitle,
    slotsTitle,
    pageType,
    hasDaysListButtonOffset = true
  } = props;
  const {
    trackEvent
  } = useGTM(pageType);
  const hasLoggedDayRef = useRef(false);
  const hasLoggedSlotRef = useRef(false);
  const handleDayClick = (day: ISchedule) => {
    if (!hasLoggedDayRef.current) {
      trackEvent('edit_day');
      hasLoggedDayRef.current = true;
    }
    onDayClick(day);
  };
  const handleSlotClick = (slot: string) => {
    if (!hasLoggedSlotRef.current) {
      trackEvent('edit_timeslot');
      hasLoggedSlotRef.current = true;
    }
    onSlotClick(slot);
  };
  useEffect(() => {
    if (selectedDay?.timeslots) {
      const slots = selectedDay.timeslots;
      if (!slots.find(item => item === selectedSlot) && slots.length) {
        setSelectedSlot(slots[0]);
      }
    }
  }, [selectedDay, selectedSlot]);
  if (!schedule.length || !selectedDay) return null;
  return <div data-testid={featureTimeslotsConfig.ids.timeslotsWrapper} data-sentry-component="TimeSlotsUI" data-sentry-source-file="TimeSlotsUI.tsx">
      {daysTitle && <p data-testid={featureTimeslotsConfig.ids.daysListTitle} className="mb-4 text-xl font-bold">
          {daysTitle}
        </p>}
      <DaysList schedule={schedule} selectedDay={selectedDay} onDayClick={handleDayClick} hasButtonsOffset={hasDaysListButtonOffset} data-sentry-element="DaysList" data-sentry-source-file="TimeSlotsUI.tsx" />

      {slotsTitle && <p data-testid={featureTimeslotsConfig.ids.timeslotsListTitle} className="my-4 text-base font-bold">
          {slotsTitle}
        </p>}

      <TimeSlotsList selectedDay={selectedDay} selectedSlot={selectedSlot} handleSlotClick={handleSlotClick} mini={mini} scrollToSelected={scrollToSelected} data-sentry-element="TimeSlotsList" data-sentry-source-file="TimeSlotsUI.tsx" />
    </div>;
};